<template>
  <div class="search-bar">
    <div class="search-bar-content flex-one jc-between">
      <el-input
        v-model="keyword"
        placeholder="输入关键词进行检索"
        class="input"
        :size="xs ? 'middle' : 'large'"
        style="border-radius: 0"
        @keydown.enter="onSearch"
        clearable
      >
        <!-- <template #prepend>
          <el-icon class="input-prepend bg-primary text-white fs-xxl"
            ><search
          /></el-icon>
        </template> -->
      </el-input>
      <el-button
        type="warning"
        class="gradient-btn btn text-black-1 fw-400 scale"
        @click="onSearch"
        :loading="props.loading"
        style="width: 70px; border-radius: 0"
        :size="xs ? 'middle' : 'large'"
      >
        <el-icon class="text-white"><Search /> </el-icon>
      </el-button>
    </div>
  </div>
</template>

<script setup>
import { defineEmits, defineProps, ref, toRaw } from 'vue'

import { Search } from '@element-plus/icons-vue'
import useSize from '@/hooks/useSize.js'

const emits = defineEmits('on-search')
const props = defineProps({
  loading: Boolean
})

const { xs } = useSize()
const keyword = ref('')

const onSearch = () => {
  console.log(toRaw(keyword))
  emits('on-search', keyword.value)
}
</script>

<style lang="scss" scoped>
.search-bar {
  $size: 40px;
  width: 100%;
  &-content {
    .btn {
      // height: $size;
    }
    // .input {
    //   &-prepend {
    //     width: $size;
    //     height: $size;
    //   }
    // }
  }
  ::v-deep {
    .el-input {
      &__wrapper {
        background-color: #dddddd;
        border-radius: 0;
      }
    }
    .el-input-group__prepend {
      padding: 0;
    }
  }
}
</style>
